module.exports = __webpack_public_path__ + "img/ehk_logo.69921894.png";